import { useEffect, useRef } from 'react';

export default function ProductsHero() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative min-h-[600px] md:min-h-[720px] bg-[#1A1A1A] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxury%20modern%20interior%20showroom%20with%20marble%20tiles%20ceramic%20surfaces%20warm%20golden%20ambient%20lighting%20elegant%20minimal%20design%20high%20end%20architecture%20photography&width=1920&height=1080&seq=phoenix-prod-hero-1&orientation=landscape"
          alt="პრემიუმ სამშენებლო მასალები"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A] via-[#1A1A1A]/80 to-transparent"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-64 h-64 border border-[#D4A853]/20 rounded-full hidden lg:block"></div>
      <div className="absolute bottom-20 right-40 w-32 h-32 border border-[#D4A853]/10 rounded-full hidden lg:block"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-32 md:pt-40 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="reveal opacity-0 mb-6">
            <span className="inline-flex items-center gap-2 bg-[#D4A853]/15 text-[#D4A853] text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full border border-[#D4A853]/20">
              <i className="ri-vip-crown-line"></i>
              პრემიუმ ხარისხი
            </span>
          </div>

          {/* Title */}
          <h1 className="reveal opacity-0 font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            პროდუქტების
            <span className="text-[#D4A853]"> კატალოგი</span>
          </h1>

          {/* Description */}
          <p className="reveal opacity-0 text-base md:text-lg text-white/70 leading-relaxed mb-8 max-w-lg">
            აღმოაჩინეთ მსოფლიოს წამყვანი ბრენდების პრემიუმ სამშენებლო მასალები. 
            კერამიკული ფილები, ბუნებრივი ქვა, სანტექნიკა და საღებავები — ყველაფერი ერთ სივრცეში.
          </p>

          {/* Stats Row */}
          <div className="reveal opacity-0 flex flex-wrap gap-8 md:gap-12 mt-10">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#D4A853]">50+</div>
              <div className="text-sm text-white/50 mt-1">ბრენდი</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#D4A853]">5000+</div>
              <div className="text-sm text-white/50 mt-1">პროდუქტი</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-[#D4A853]">25+</div>
              <div className="text-sm text-white/50 mt-1">წელი გამოცდილება</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 80V40C240 80 480 0 720 0C960 0 1200 80 1440 40V80H0Z" fill="#F5F0E8"/>
        </svg>
      </div>
    </section>
  );
}